// extracted by mini-css-extract-plugin
export default {"input":"DiscountInput-input_phaU3","discountAdded":"DiscountInput-discountAdded_OGG1S"};